export const saveInstituteFormData = (InstituteFormData) => {
    return {
   type: 'SAVE_FORM_INSTITUTE_DATA',
   InstituteFormData
   }};
 